
import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Cookies from "js-cookie";

// Layouts & Components
import MainLayout from "./layouts/MainLayout";
import Login from "./components/Login";
import Createbooking from "./components/Createbooking";
import BookingDetailPage from "./components/BookingDetailPage";
import Customer from "./components/Customer";
import Broker from "./components/Broker";
import RegisteredBrokerList from "./components/RegisteredBrokerList";
import BookingTransactionList from "./components/BookingTransactionList";
import CustomerList from "./components/CustomerList";
import Site from "./components/Site";
import Plot from "./components/Plot";
import SiteList from "./components/SiteList";
import PlotList from "./components/PlotList";
import BookedDetailpage from "./components/BookedDetailpage";
import BookingPlotDetails from "./components/BookingPlotDetails";
import Associatebookingsdetails from "./components/Associatebookingsdetails";
import BookingPrintpage from "./components/BookingPrintpage";
import UpdatePlot from "./components/UpdatePlot";
import UpdateCustomer from "./components/UpdateCustomer";
import Updateassociate from "./components/Updateassociate";
import SeeTransaction from "./components/SeeTransaction";
import Commission from "./components/Commission";
import AssociatePayment from "./components/AssociatePayment";
import TransactionPrint from "./components/TransactionPrint";
import BookingPayment from "./components/BookingPayment";
import SeeTransactionPayment from "./components/SeeTransactionPayment";
import SeeTransactionSlip from "./components/SeeTransactionSlip";
import CreateUser from "./components/CreateUser";
import ChangePassword from "./components/ChangePassword";
import UpdateTransaction from "./components/UpdateTransaction";
import ChangePlot from "./components/ChangePlot";
import SeeCanceledBooking from "./components/SeeCanceledBooking";
import { BreadcrumbProvider } from "./context/BreadcrumbContext";

const App = () => {
  const [newCustomer, setNewCustomer] = useState(null);
  const [newBroker, setNewBroker] = useState(null);
  const [newTransaction, setNewTransaction] = useState(null);
  const [newBooking, setNewBooking] = useState(null);
  const [newPlot, setNewPlot] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const token = Cookies.get("authToken");
    if (token) setIsLoggedIn(true);
  }, []);

  // Called by the Login page after we successfully receive & store the auth token.
  const handleLogin = () => setIsLoggedIn(true);

  return (
    <BrowserRouter>
    <BreadcrumbProvider >

      <Toaster position="top-center" />

      {!isLoggedIn ? (
        <Routes>
          <Route
            path="/"
            element={<Login onLogin={handleLogin} />}
          />
          <Route
            path="/login"
            element={<Login onLogin={handleLogin} />}
          />
        </Routes>
      ) : (
        <MainLayout isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn}>
          <Routes>
            <Route path="/" element={<Navigate to="/allbooking" />} />
            <Route
              path="/createbooking"
              element={<Createbooking onBookingCreated={setNewBooking} />}
            />
            <Route
              path="/BookingPrintpage/:bookingId"
              element={isMobile ? <Navigate to="/" /> : <BookingPrintpage />}
            />
            <Route path="/transactionprint/:broker_id" element={<TransactionPrint />} />
            <Route path="/bookingpayment" element={<BookingPayment />} />
            <Route path="/allbooking" element={<BookingDetailPage newBooking={newBooking} />} />
            <Route
              path="/bookingtransactionlists"
              element={
                <BookingTransactionList
                  onTransactionCreated={setNewTransaction}
                  newTransaction={newTransaction}
                />
              }
            />
            <Route path="/seetransactionpayment" element={<SeeTransactionPayment />} />
            <Route path="/seetransaction/:booking_id" element={<SeeTransaction />} />
            <Route path="/changeplot/:booking_id" element={<ChangePlot />} />
            <Route path="/seetransactionslip/:transactionId" element={<SeeTransactionSlip />} />
            <Route path="/customerlists" element={<CustomerList newCustomer={newCustomer} />} />
            <Route
              path="/createcustomer"
              element={<Customer onCustomerCreated={setNewCustomer} />}
            />
            <Route path="/allassociate" element={<RegisteredBrokerList newBroker={newBroker} />} />
            <Route
              path="/createassociate"
              element={<Broker onBrokerCreated={setNewBroker} />}
            />
            <Route path="/associatepayment/:broker_id" element={<AssociatePayment />} />
            <Route path="/commission" element={<Commission />} />
            <Route path="/createsite" element={<Site />} />
            <Route path="/sitelists" element={<SiteList />} />
            <Route path="/createplot" element={<Plot onPlotCreated={setNewPlot} />} />
            <Route path="/plotlists" element={<PlotList newPlot={newPlot} />} />
            <Route path="/customerlist" element={<CustomerList />} />
            <Route path="/BookedDetailpage/:bookedId" element={<BookedDetailpage />} />
            <Route path="/seecanceledbooking" element={<SeeCanceledBooking />} />
            <Route path="/bookingpayment/:transactionId" element={<BookingPayment />} />
            <Route path="/BookingPlotDetails/:customerId" element={<BookingPlotDetails />} />
            <Route
              path="/associatebookingsdetails/:associateid"
              element={<Associatebookingsdetails />}
            />
            <Route path="/updatecustomer/:updatecustomerid" element={<UpdateCustomer />} />
            <Route path="/updatetransaction" element={<UpdateTransaction />} />
            <Route path="/updateassociate/:updateassociateid" element={<Updateassociate />} />
            <Route path="/updateplot/:updateplotid" element={<UpdatePlot />} />
            <Route path="/createuser" element={<CreateUser />} />
            <Route path="/changepassword" element={<ChangePassword />} />
          </Routes>
        </MainLayout>
      )}
    </BreadcrumbProvider>

    </BrowserRouter>

  );
};

export default App;
